import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Space } from 'antd';
import { ClockCircleOutlined, GlobalOutlined } from '@ant-design/icons';
import useResponsive from '@/hooks/useResponsive';

// Extend dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);

const TimeDisplay: React.FC = () => {
  const { screens } = useResponsive();
  const [time, setTime] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(dayjs());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!screens.lg) {
    return null;
  }

  return (
    <Space className="bo-header-time" size={screens.xxl ? 'large' : 'small'}>
      {screens.xxl ? (
        <span title="Local Time">
          <ClockCircleOutlined style={{ marginRight: 4 }} />
          Local: {time.format('HH:mm:ss')}
        </span>
      ) : null}
      <span title="Myanmar Time (UTC+6:30)">
        <GlobalOutlined style={{ marginRight: 4 }} />
        {screens.xxl ? 'Myanmar: ' : ''}
        {time.tz('Asia/Yangon').format('HH:mm:ss')}
      </span>
    </Space>
  );
};

export default TimeDisplay;
